import {createNav, main, navigateToHref, router, routes, setBreadcrumb, setTitle, switchTo} from './main.js';
import {requestJSON} from './utils.js';

let firstDate;
let firstSelector;
let lastDate;
let lastSelector;
let elem;
let prevElem;
let nextElem;
let closeElem;
let keydownListenerAttached = false;
let subnavItems = [
	{
		name: "Fotky",
		routeName: "photo.list",
	},
	{
		name: "Alba",
		routeName: "album.list",
	},
];

function showPhoto(attributes)
{
	requestJSON('POST', routes["photo.detail"], attributes, function (xhr) {
		let data = xhr.response;

		setTitle(data.filename);
		/*
		setBreadcrumb([
			{title: "Fotky", url: router.generateUrl("photo.list")},
			{title: data.filename}
		]);
		switchTo(document.querySelector(".js-nav-photos"));
		*/

		let detailElem = document.getElementById("photo-detail");

		if (!detailElem) {
			detailElem = document.createElement("div");
			detailElem.id = "photo-detail";
			detailElem.classList.add("photo-detail");
			main.appendChild(detailElem);
		} else {
			detailElem.textContent = "";
		}

		let frameElem = document.createElement("div");
		frameElem.classList.add("photo-detail-frame");
		detailElem.appendChild(frameElem);

		let thumbElem = document.createElement("img");
		thumbElem.classList.add("photo-detail-img");
		//thumbElem.src = photos[i].thumbnail.w1920;
		thumbElem.src = data.thumbnail.w1920;
		frameElem.appendChild(thumbElem);

		prevElem = document.createElement("a");
		prevElem.href = ("album_selector" in attributes)
			? router.generateUrl("album.photo.detail", {album_selector: attributes.album_selector, selector: data.previous})
			: router.generateUrl("photo.detail", {selector: data.previous});
		prevElem.classList.add("photo-detail-prev");
		prevElem.addEventListener("click", (data.previous != null) ? navigateToHref : e => e.preventDefault());
		prevElem.innerHTML = `<i class="fas fa-chevron-left"></i>`;

		if (data.previous != null) {
			frameElem.appendChild(prevElem);
		}

		nextElem = document.createElement("a");
		nextElem.href = ("album_selector" in attributes)
			? router.generateUrl("album.photo.detail", {album_selector: attributes.album_selector, selector: data.next})
			: router.generateUrl("photo.detail", {selector: data.next});
		nextElem.classList.add("photo-detail-next");
		nextElem.addEventListener("click", (data.next != null) ? navigateToHref : e => e.preventDefault());
		nextElem.innerHTML = `<i class="fas fa-chevron-right"></i>`;

		if (data.next != null) {
			frameElem.appendChild(nextElem);
		}

		let modeElem = document.createElement("a");
		modeElem.classList.add("photo-detail-mode");
		modeElem.addEventListener("click", e => {
			e.preventDefault();
			let iconElem = modeElem.querySelector("i");
			iconElem.classList.toggle("fa-info");
			iconElem.classList.toggle("fa-expand");
			detailElem.classList.toggle("photo-detail-fullscreen");
		});
		modeElem.innerHTML = `<i class="fas ${detailElem.classList.contains("photo-detail-fullscreen") ? "fa-info" : "fa-expand"}"></i>`;
		frameElem.appendChild(modeElem);

		// TODO: better "back to list"
		closeElem = document.createElement("a");

		closeElem.href = ("album_selector" in attributes)
			? router.generateUrl("album.detail", {selector: attributes.album_selector})
			: router.generateUrl("photo.after", {after: data.created_on.substring(0,7)});

		closeElem.classList.add("photo-detail-close");
		closeElem.addEventListener("click", navigateToHref);
		closeElem.innerHTML = `<i class="fas fa-times"></i>`;
		frameElem.appendChild(closeElem);

		//detailElem.addEventListener("click", function (e) {
		//	this.remove();
		//});

		if (!keydownListenerAttached) {
			window.addEventListener("keydown", event => {
				switch (event.key) {
					case "ArrowLeft":
						prevElem.click();
						break;
					case "ArrowRight":
						nextElem.click();
						break;
					case "Escape":
						closeElem.click();
						break;
				}
			});

			keydownListenerAttached = true;
		}

		let intlOptions = {
			weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
			hour: 'numeric', minute: 'numeric'
		};
		let intl = new Intl.DateTimeFormat(navigator.language, intlOptions);

		let infoElem = document.createElement("div");
		infoElem.classList.add("photo-detail-info");
		infoElem.innerHTML = `<dl>
	<dt>Název</dt>
	<dd>${data.filename}</dd>
	<dt>Datum a čas</dt>
	<dd><time datetime="${data.created_on}">${intl.format(new Date(data.created_on))}</time></dd>
</dl>`;
		detailElem.appendChild(infoElem);
	});
}

function showPhotos()
{
	setTitle("Fotky");
	setBreadcrumb([{title: "Fotky"}]);
	switchTo(document.querySelector(".js-nav-photos"));

	main.textContent = '';

	elem = document.createElement("section");
	elem.classList.add("tile");
	elem.appendChild(createNav(subnavItems, 0));
	let body = document.createElement("div");
	body.classList.add("js-years-body", "tile-body", "tile-body-years");
	elem.appendChild(body);

	main.appendChild(elem);

	fetchYears(routes["photo.year"], "photo.after");
}

function showAlbums()
{
	setTitle("Alba");
	setBreadcrumb([{title: "Alba"}]);
	switchTo(document.querySelector(".js-nav-photos"));

	main.textContent = '';

	elem = document.createElement("section");
	elem.classList.add("tile");
	elem.appendChild(createNav(subnavItems, 1));
	let body = document.createElement("div");
	body.classList.add("js-years-body", "tile-body", "tile-body-years");
	elem.appendChild(body);

	main.appendChild(elem);

	fetchYears(routes["photo.album.year"], "album.after");
}

function showAlbum(attributes)
{
	requestJSON('POST', routes["photo.album.detail"], {selector: attributes.selector}, function (xhr) {
		let data = xhr.response;

		setTitle(data.name);
		setBreadcrumb([
			{title: "Alba", url: router.generateUrl("album.list")},
			{title: data.name}
		]);
		switchTo(document.querySelector(".js-nav-photos"));

		main.textContent = '';

		firstDate = "";
		firstSelector = "";
		lastDate = "";
		lastSelector = "";

		elem = document.createElement("section");
		elem.classList.add("tile", "thumbnails-160w");

		let heading = document.createElement("h2");
		heading.textContent = data.name;

		elem.appendChild(heading);
		main.appendChild(elem);

		fetchPhotos({album: attributes.selector});
	});
}

function showAlbumsTimeline(attributes)
{
	setTitle("Alba po " + attributes.after);
	setBreadcrumb([
		{title: "Alba", url: router.generateUrl("album.list")},
		{title: attributes.after}
	]);
	switchTo(document.querySelector(".js-nav-photos"));

	main.textContent = '';

	firstDate = "";
	firstSelector = "";
	lastDate = "";
	lastSelector = "";

	let sectionElem = document.createElement("section");
	sectionElem.classList.add("tile");

	let heading = document.createElement("h2");
	heading.textContent = "Časová osa";
	sectionElem.appendChild(heading);

	elem = document.createElement("div");
	elem.classList.add("list-group");
	sectionElem.appendChild(elem);

	main.appendChild(sectionElem);

	fetchAlbums({after: attributes.after});
}

function showTimeline(attributes)
{
	setTitle("Fotky po " + attributes.after);
	setBreadcrumb([
		{title: "Fotky", url: router.generateUrl("photo.list")},
		{title: attributes.after}
	]);
	switchTo(document.querySelector(".js-nav-photos"));

	main.textContent = '';

	firstDate = "";
	firstSelector = "";
	lastDate = "";
	lastSelector = "";

	elem = document.createElement("section");
	elem.classList.add("tile", "thumbnails-160w");
	main.appendChild(elem);

	fetchPhotos({after: attributes.after});
}

function fetchAlbums(parameters)
{
	// toLocaleDateString options
	let options = {
		month: 'long', year: 'numeric',
	};
	let albumOptions = {
		weekday: 'long', month: 'numeric', day: 'numeric',
	};

	// parameters either: preceding: selector, following: selector, before: date, after: date
	let ascending = !("before" in parameters || "preceding" in parameters);

	let albumsElem = elem;

	requestJSON('POST', routes["photo.album.list"], parameters, function (xhr) {
		let albums = xhr.response;

		for (let i in albums) {
			let albumElem = document.createElement("div");
			albumElem.classList.add("list-group-item");
			let linkElem = document.createElement("a");
			linkElem.textContent = albums[i].name;
			linkElem.href = router.generateUrl("album.detail", {selector: albums[i].selector});
			linkElem.addEventListener("click", navigateToHref);
			albumElem.appendChild(linkElem);
			let infoElem = document.createElement("span");
			infoElem.style.marginLeft = "1em";
			infoElem.classList.add("text-black-50");
			infoElem.textContent = new Date(albums[i].created_on).toLocaleDateString(navigator.language, albumOptions);
			albumElem.appendChild(infoElem);

			let albumDate = albums[i].created_on.substr(0, 7);

			if (firstDate == "") {
				firstDate = albumDate;
				firstSelector = albums[i].selector;
			}

			if (ascending) {
				lastSelector = albums[i].selector;

				if (lastDate != albumDate) {
					lastDate = albumDate;
					let headingElem = document.createElement("h3");
					headingElem.textContent = new Date(lastDate).toLocaleDateString(navigator.language, options);
					albumsElem.appendChild(headingElem);
				}

				albumsElem.appendChild(albumElem);
			} else {
				firstSelector = albums[i].selector;

				if (firstDate != albumDate) {
					firstDate = albumDate;
					let headingElem = document.createElement("h3");
					headingElem.textContent = new Date(firstDate).toLocaleDateString(navigator.language, options);
					albumsElem.insertBefore(headingElem, albumsElem.firstChild);
				}

				albumsElem.insertBefore(albumElem, albumsElem.firstChild.nextSibling);
			}
		}

		if (ascending) {
			let moreButton = document.createElement("button");
			moreButton.type = "button";
			moreButton.textContent = "Následující";
			moreButton.addEventListener("click", function (e) {
				fetchAlbums({following: lastSelector});
				this.remove();
			});
			albumsElem.appendChild(moreButton);
		}

		if (!ascending || "after" in parameters) {
			let moreButton = document.createElement("button");
			moreButton.type = "button";
			moreButton.textContent = "Předchozí";
			moreButton.addEventListener("click", function (e) {
				fetchAlbums({preceding: firstSelector});
				this.remove();
			});
			albumsElem.insertBefore(moreButton, albumsElem.firstChild);
		}
	});
}

function fetchPhotos(parameters)
{
	// toLocaleDateString options
	let options = {
		weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
	};

	// parameters either: preceding: selector, following: selector, before: date, after: date, album: album_selector
	let ascending = !("before" in parameters || "preceding" in parameters);

	let photosElem = elem;

	requestJSON('POST', routes["photo.list"], parameters, function (xhr) {
		let photos = xhr.response;

		for (let i in photos) {
			let photoElem = document.createElement("div");
			let imgElem = document.createElement("a");
			imgElem.href = ("album" in parameters)
				? router.generateUrl("album.photo.detail", {album_selector: parameters.album, selector: photos[i].selector})
				: router.generateUrl("photo.detail", {selector: photos[i].selector});
			imgElem.addEventListener("click", navigateToHref);
			photoElem.appendChild(imgElem);

			let thumbElem = document.createElement("img");
			thumbElem.alt = photos[i].filename;
			thumbElem.src = photos[i].thumbnail.w160;
			thumbElem.loading = "lazy";
			imgElem.appendChild(thumbElem);

			let photoDate = photos[i].created_on.substr(0, 10);

			if (firstDate == "") {
				firstDate = photoDate;
				firstSelector = photos[i].selector;
			}

			if (ascending) {
				lastSelector = photos[i].selector;

				if (lastDate != photoDate) {
					lastDate = photoDate;
					let headingElem = document.createElement("h3");
					headingElem.textContent = new Date(lastDate).toLocaleDateString(navigator.language, options);
					photosElem.appendChild(headingElem);
				}

				photosElem.appendChild(photoElem);
			} else {
				firstSelector = photos[i].selector;

				if (firstDate != photoDate) {
					firstDate = photoDate;
					let headingElem = document.createElement("h3");
					headingElem.textContent = new Date(firstDate).toLocaleDateString(navigator.language, options);
					photosElem.insertBefore(headingElem, photosElem.firstChild);
				}

				photosElem.insertBefore(photoElem, photosElem.firstChild.nextSibling);
			}
		}

		if (ascending) {
			let moreButton = document.createElement("button");
			moreButton.type = "button";
			moreButton.textContent = "Následující";
			moreButton.addEventListener("click", function (e) {
				let params = {...parameters};
				delete params.preceding;
				params.following = lastSelector;
				delete params.before;
				delete params.after;

				fetchPhotos(params);
				this.remove();
			});
			photosElem.appendChild(moreButton);
		}

		if (!ascending || "after" in parameters) {
			let moreButton = document.createElement("button");
			moreButton.type = "button";
			moreButton.textContent = "Předchozí";
			moreButton.addEventListener("click", function (e) {
				let params = {...parameters};
				params.preceding = firstSelector;
				delete params.following;
				delete params.before;
				delete params.after;

				//fetchPhotos({...{preceding: firstSelector}, ...parameters});
				fetchPhotos(params);
				this.remove();
			});
			photosElem.insertBefore(moreButton, photosElem.firstChild);
		}
	});
}

function fetchYears(route, routeName)
{
	requestJSON('POST', route, null, function (xhr) {
		for (let year in xhr.response) {
			let yearElem = document.createElement("div");
			let headingElem = document.createElement("h3");
			let yearLink = document.createElement("a");
			yearLink.href = router.generateUrl(routeName, {after: year.toString()});
			yearLink.textContent = year;
			yearLink.addEventListener("click", navigateToHref);
			headingElem.appendChild(yearLink);
			yearElem.appendChild(headingElem);
			let listElem = document.createElement("ul");
			listElem.classList.add("list-group", "list-group-slim");
			let months = xhr.response[year];
			for (let month in months) {
				let monthElem = document.createElement("li");
				monthElem.classList.add("list-group-item");
				let monthLink = document.createElement("a");
				monthLink.href = router.generateUrl(routeName, {after: year.toString() + "-" + month.toString().padStart(2, "0")});
				monthLink.textContent = new Date(year, parseInt(month) - 1).toLocaleDateString(navigator.language, {month: 'long'});
				monthLink.addEventListener("click", navigateToHref);
				monthElem.appendChild(monthLink);
				let countElem = document.createElement("span");
				countElem.classList.add("text-black-50");
				countElem.textContent = months[month];
				monthElem.appendChild(countElem);
				listElem.appendChild(monthElem);
			}
			yearElem.appendChild(listElem);
			elem.querySelector(".js-years-body").appendChild(yearElem);
		}
	});
}

export {
	showAlbum,
	showAlbums,
	showAlbumsTimeline,
	showPhoto,
	showPhotos,
	showTimeline,
};
